import { requiredFormFields } from '../../const/app';
import { store } from '../../store/store';
import { getRoutes } from '../router/getRoutes';

export const getLatestValidStepIndex = (): number => {
  const snapshot = store.getSnapshot();
  const formData = snapshot.context.form;
  const { formStepRoutes } = getRoutes();

  for (let i = 0; i < formStepRoutes.length; i++) {
    const stepKey = formStepRoutes[i].stepKey;
    if (!stepKey) {
      continue;
    }
    const stepFormData = formData[stepKey];
    const requiredFields = requiredFormFields[stepKey];

    if (
      !stepFormData ||
      !requiredFields.every((field) => stepFormData[field as keyof typeof stepFormData])
    ) {
      return i;
    }
  }

  return formStepRoutes.length - 1;
};
